import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import media from '../../utils/mediaQueries';
import IconCheck from '../../images/icon-success.inline.svg';
import IconCross from '../../images/icon-error.inline.svg';

const Container = styled.section`
  margin-top: 24px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  flex-direction: column;
  
  ${media.mobile`
    height: auto;
  `}
`;

const IconSuccess = styled(IconCheck)`
  width: 48px;
  height: 48px;
  margin-bottom: 24px;
  
  ${media.mobile`
    width: 32px;
    height: 32px;
  `}
`;

const IconError = styled(IconCross)`
  width: 48px;
  height: 48px;
  margin-bottom: 24px;
  
  ${media.mobile`
    width: 32px;
    height: 32px;
  `}
`;

const Result = ({ isSuccess }) => (
  <Container>
    {isSuccess ? <IconSuccess /> : <IconError />}
    {isSuccess
      ? 'La demande a été envoyée avec succès'
      : 'Une erreur est survenue, veuillez réessayer'}
  </Container>
);

Result.propTypes = {
  isSuccess: PropTypes.bool,
};

Result.defaultProps = {
  isSuccess: true,
};

export { Result };
